import type {FC} from 'react';
import {memo} from 'react';

import Close from '@yourcoach/shared/assets/icons/close.svg';

interface Props {
  customClass?: string;
  height?: string;
  width?: string;
}

const IconClose: FC<Props> = ({
  customClass = '',
  height = '100%',
  width = '100%',
}) => {
  return (
    <Close
      className={`${customClass}`}
      fill="#819AA9"
      height={width}
      width={height}
    />
  );
};

export default memo(IconClose);
